import axios from 'axios';

const ibgeApi = axios.create({
    baseURL: 'https://servicodados.ibge.gov.br/api/v1/localidades'
});

export async function getUfsAll() {
    return await ibgeApi.get('/estados?orderBy=nome')
}

export async function getCityFromUf(uf) {
    return await ibgeApi.get(`estados/${uf}/municipios`)
}

export default ibgeApi